export default {
  FETCH_COMMUNITY_POSTS_PAGE_POSTS: 'FETCH_COMMUNITY_POSTS_PAGE_POSTS',
  FETCH_COMMUNITY_POSTS_PAGE_POSTS_SUCCESS: 'FETCH_COMMUNITY_POSTS_PAGE_POSTS_SUCCESS',
  FETCH_COMMUNITY_POSTS_PAGE_POSTS_FAILURE: 'FETCH_COMMUNITY_POSTS_PAGE_POSTS_FAILURE',

  FETCH_COMMUNITY_TOP_TAGS: 'FETCH_COMMUNITY_TOP_TAGS',
  FETCH_COMMUNITY_TOP_TAGS_SUCCESS: 'FETCH_COMMUNITY_TOP_TAGS_SUCCESS',
  FETCH_COMMUNITY_TOP_TAGS_FAILURE: 'FETCH_COMMUNITY_TOP_TAGS_FAILURE',

  FETCH_POSTS_PINNED_POSTS: 'FETCH_POSTS_PINNED_POSTS',
  FETCH_POSTS_PINNED_POSTS_SUCCESS: 'FETCH_POSTS_PINNED_POSTS_SUCCESS',
  FETCH_POSTS_PINNED_POSTS_FAILURE: 'FETCH_POSTS_PINNED_POSTS_FAILURE',

  FETCH_COMMUNITY_TOPICS: 'FETCH_COMMUNITY_TOPICS',
  FETCH_COMMUNITY_TOPICS_SUCCESS: 'FETCH_COMMUNITY_TOPICS_SUCCESS',
  FETCH_COMMUNITY_TOPICS_FAILURE: 'FETCH_COMMUNITY_TOPICS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/community/communityPosts/actionTypes.js